<!--
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-09-14 14:35:25
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-25 10:10:32
-->
<template>
    <el-dialog
        custom-class="jy-use-dialog"
        :visible.sync="iShow"
        modal-append-to-body
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeAction"
        width="380px"
    >
        <div class="user-comit-dialog">
            <img class="heades-title" src="../images/blue_login@2x.png" alt />

            <el-form class="form-main" ref="form" :model="form" label-width="0">
                <el-form-item
                    v-for="(item,index) in formData"
                    :key="index"
                    :rules="item.rules"
                    :prop="item.field"
                >
                    <el-input
                        v-if="item.sType === 'text'"
                        v-model="form[item.field]"
                        size="medium"
                        :placeholder="item.label"
                    >
                        <i slot="prefix" class="el-input__icon iconfont iconshouji"></i>
                    </el-input>

                    <div v-if="item.sType === 'code'" class="input-li">
                        <el-input
                            v-model="form[item.field]"
                            :placeholder="item.label"
                            size="medium"
                            :type="item.inputType"
                        >
                            <i slot="prefix" class="el-input__icon iconfont iconyanzheng"></i>
                        </el-input>
                        <div class="opt-btns" v-if="isSendingCode">{{codeSecond}}秒</div>
                        <div v-else class="opt-btns" @click="send_sms_code">发送验证码</div>
                    </div>

                    <div v-if="item.sType === 'password'">
                        <el-input
                            v-model="form[item.field]"
                            :placeholder="item.label"
                            size="medium"
                            :type="item.inputType"
                        >
                            <i slot="prefix" class="el-input__icon iconfont iconmima"></i>
                            <i
                                slot="suffix"
                                v-if="item.inputType === 'password'"
                                class="el-input__icon iconfont iconbiyan"
                                @click="item.inputType = 'text'"
                            ></i>
                            <i
                                slot="suffix"
                                v-if="item.inputType === 'text'"
                                class="el-input__icon iconfont iconzhengyan"
                                @click="item.inputType = 'password'"
                            ></i>
                        </el-input>
                    </div>
                </el-form-item>

                <div v-if="!withoutAuth" class="commit-btn" @click="submitForm('form')">提交修改</div>
                <div v-else class="commit-btn no-auth" @click="submitForm('form')">提交修改</div>
            </el-form>
        </div>
    </el-dialog>
</template>
<script>
import commonMixin from '../common/mixin'
import { mapActions } from 'vuex'
export default {
    mixins: [commonMixin],
    props: {
        dialogVisible: {
            type: Boolean,
            default: true
        },
        withoutAuth: Boolean
    },
    data() {
        return {
            iShow: true,
            form: {
                sPhone: '',
                sCode: '',
                sPassword: '',
                sPassword2: ''
            },
            formData: [
                {
                    label: '请输入手机号',
                    field: 'sPhone',
                    sType: 'text',
                    rules: [
                        {
                            trigger: 'blur',
                            required: true,
                            validator: (rule, value, callback) => {
                                if (value === '') {
                                    callback(new Error('请填写手机号'))
                                } else {
                                    let pattern = /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                                        flag = pattern.test(value)
                                    if (!flag) {
                                        callback(new Error('格式不正确'))
                                    }
                                    callback()
                                }
                            }
                        }
                    ]
                },
                {
                    label: '请输入验证码',
                    field: 'sCode',
                    sType: 'code',
                    rules: [
                        {
                            trigger: 'blur',
                            required: true,
                            validator: (rule, value, callback) => {
                                if (value === '') {
                                    callback(new Error('请输入验证码'))
                                } else {
                                    callback()
                                }
                            }
                        }
                    ],
                    optType: 'code'
                },
                {
                    label: '请输入新密码',
                    field: 'sPassword',
                    sType: 'password',
                    inputType: 'password',
                    rules: [
                        {
                            trigger: 'blur',
                            required: true,
                            validator: (rule, value, callback) => {
                                if (value === '') {
                                    callback(new Error('请输入新密码'))
                                } else {
                                    callback()
                                }
                            }
                        }
                    ]
                },
                {
                    label: '确认新密码',
                    field: 'sPassword2',
                    sType: 'password',
                    inputType: 'password',
                    rules: [
                        {
                            trigger: 'blur',
                            required: true,
                            validator: (rule, value, callback) => {
                                if (value === '') {
                                    callback(new Error('请输入新密码'))
                                } else if (value !== this.form.sPassword) {
                                    callback(new Error('两次密码不一样！'))
                                } else {
                                    callback()
                                }
                            }
                        }
                    ]
                }
            ]
        }
    },
    watch: {
        dialogVisible: {
            immediate: true,
            handler(val) {
                this.iShow = val
            }
        }
    },
    methods: {
        ...mapActions('user', {
            forget: 'forget'
        }),

        submitForm(formName) {
            let params = {
                sPhone: this.form.sPhone,
                sPassword: this.form.sPassword,
                sPassword2: this.form.sPassword2,
                sCode: this.form.sCode
            }
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let res = await this.forget(params)
                    if (res.data.ErrorCode === 200) {
                        this.$message.success('修改成功，请您登陆')
                        this.registerSuccess()
                    } else {
                        this.$message.error(res.data.ErrorMessage)
                    }
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        closeAction() {
            this.$emit('close')
        },
        registerSuccess() {
            this.$emit('toLogin')
        }
    }
}
</script>
<style lang="scss" scoped>
@import 'index.scss';
</style>
